import React from 'react';
import { Pagination } from 'antd';
import {
  Package,
  Plus,
  Download,
  Upload as UploadIcon,
  Minimize2,
  Smartphone,
  FileSpreadsheet,
} from 'lucide-react';
import { Button } from '@crc-evans/ui-components';
import SparesModernDataGrid from './DPR/SparesModernDataGrid';
import './DPR/DPRSettingsSparesTab.css';

/**
 * Full-screen expanded spares view — same modern grid + column search as the main tab.
 */
const SparesExpandView = ({
  onClose,
  showModal,
  setIsKitModalVisible,
  handlePublish,
  handleDownloadExcelSheet,
  handleDownloadTemplate,
  setOpenUploadModal,
  onFetchPage,
  gridProps,
  sparesDataCount,
  current,
  setCurrent,
  currentPagesize,
  setCurrentPagesize,
  isWriteAccess,
}) => {
  return (
    <div
      className="dpr-settings-spares-expand"
      role="dialog"
      aria-modal="true"
      aria-label="Spares expanded view"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div className="dpr-settings-spares-expand-inner" onClick={(e) => e.stopPropagation()}>
        <div className="dpr-settings-spares-card">
          <div className="dpr-settings-spares-header">
            <div className="dpr-settings-spares-header-left">
              <div className="dpr-settings-spares-icon-wrap">
                <Package size={24} aria-hidden />
              </div>
              <div className="dpr-settings-spares-header-content">
                <div className="dpr-settings-spares-title-row">
                  <h3 className="dpr-settings-spares-title">List of Spares</h3>
                  <span className="dpr-settings-spares-summary">{sparesDataCount ?? 0} total</span>
                </div>
                <p className="dpr-settings-spares-description">
                  Full-screen view — same filters and sorting as the Spares tab. Minimize to return.
                </p>
              </div>
            </div>
            <div className="dpr-settings-spares-actions">
              <Button
                label="Export Excel"
                variant="tertiary"
                size="small"
                icon={FileSpreadsheet}
                onClick={handleDownloadExcelSheet}
              />
              <Button
                label="Template"
                variant="tertiary"
                size="small"
                icon={Download}
                onClick={handleDownloadTemplate}
              />
              <Button
                label="Upload"
                variant="tertiary"
                size="small"
                icon={UploadIcon}
                onClick={() => setOpenUploadModal(true)}
              />
              <Button
                label="Minimize"
                variant="tertiary"
                size="small"
                icon={Minimize2}
                onClick={onClose}
              />
              <Button
                label="Publish in app"
                variant="tertiary"
                size="small"
                icon={Smartphone}
                onClick={() => !isWriteAccess && handlePublish()}
                disabled={isWriteAccess}
              />
              <Button
                label="Add kit"
                variant="tertiary"
                size="small"
                icon={Plus}
                onClick={() => !isWriteAccess && setIsKitModalVisible(true)}
                disabled={isWriteAccess}
              />
              <Button
                label="Add individual spare"
                variant="primary"
                size="small"
                icon={Plus}
                onClick={showModal}
                disabled={isWriteAccess}
              />
            </div>
          </div>

          <SparesModernDataGrid {...gridProps} tableWrapClassName="" />

          {sparesDataCount > 0 && (
            <div className="dpr-settings-spares-pagination">
              <Pagination
                className="heat-profile-pagination"
                showSizeChanger
                pageSizeOptions={['10', '20', '50', '100']}
                current={current}
                pageSize={currentPagesize}
                total={sparesDataCount}
                onChange={async (pageNumber, pageSize) => {
                  setCurrent(pageNumber);
                  setCurrentPagesize(pageSize);
                  await onFetchPage(pageNumber, pageSize);
                }}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SparesExpandView;
